import React, { useState, useMemo } from 'react'
import Axios from 'axios'
import moment from 'moment'
import Table from '../_components/Table'
import { TopBar, ModalComponent } from '../_components'
import BannerImg from '../_images/it_certification_pc.png'

export default function Home() {
  const [ showText, setShowText] = useState("")
  const [ showRequiredDocuments, setShowRequiredDocuments] = useState(false)
  const [ showCertifiedCompanies, setShowCertifiedCompanies] = useState(false)
  const [ showItcoPrivacyNotice, setShowItcoPrivacyNotice] = useState(false)
  const [ loading, setLoading ] = useState( true )
  const [ records, setRecords ] = useState( [] )

  React.useEffect( () => {
    if( loading ) {
        fetchApplications()
    }
  },[ loading ])

  const downloadCertifiedCompanies = async () => {
    try {
      const url = process.env.REACT_APP_API_URL+`/api/auth/view_all_certified_companies`
      const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    } catch (error) {}
  }

  const fetchApplications = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/get_valid_certificates` ) 
      if( response.data ) {
        const results = response.data.map( ( result, index ) => {
            return {
                recordId: `${index+1}`,
                applicant: result.trading_name,
                annual_income: result.annual_turnover,
                isic_codes: result.service_name,
                certificate_expiry_date: moment( result.certificate_expiry_date ).format( "DD MMM, YYYY" ),
                certificate_issue_date: moment( result.issued_on ).format( "DD MMM, YYYY" ),
                certificate_number: result.certificate_serial_number,
                email_address: result.created_by,
                date: moment( result.created_at ).format( "DD MMM, YYYY" ),
                status: result.status,
                id: result.id
            }
        } )

        setRecords( results )
        setLoading( false )
      }
    } catch (error) {
        //alert( "Server error occured." )
        setLoading( false )
    }
  }

  const DetailsField = ( record ) => {
    return (
      <div onClick={async () => {
        try {
            const url = process.env.REACT_APP_API_URL+`/api/auth/view_company_certificate/${record.value}`
            const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
        } catch (error) {}
        } } className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
        {`View`}
      </div>
    )
  }

  const columns = useMemo( () => [
    {
    Header: "#",
    accessor: "recordId"
    },
    {
    Header: "Company",
    accessor: "applicant"
    },
    {
    Header: "Certificate No.",
    accessor: "certificate_number"
    },
    {
      Header: "Issue Date",
      accessor: "certificate_issue_date"
    },
    {
    Header: "Expiry Date",
    accessor: "certificate_expiry_date"
    },
    {
    Header: "Action",
    accessor: "id",
    Cell: DetailsField
    }
  ] )

  const handlePress = async ( tag ) => {
    //console.log("clicked registration")
    await localStorage.setItem( "link", tag )
    return window.location.reload()
  }

  const handleChildStateChange = (newState) => {
    setShowText(newState)
    //console.log("bubbled up here")
  }

  return (
    <div className="w-screen min-h-screen bg-white-50 overflow-x-hidden">
        <TopBar home onStateChange={handleChildStateChange} />

        <div className="flex-grow w-full">
          <div className="h-60 sm:h-72 md:h-80 bg-cover bg-center">
            {/* <img src={BannerImg} className="w-full object-contain"/> */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4 sm:p-6 md:p-10">
              { (showText === "" || showText === "privacy_policy" || showText === "cookie_notice") && 
                <div className="flex flex-col content-start pt-5 px-20">
                  <div className="pt-4">
                    <button className="inline-flex w-full justify-center rounded-md bg-[#aec836] px-6 py-4 font-semibold text-white hover:bg-[#8aae14] sm:ml-3 sm:w-auto cursor-pointer" onClick={() => handlePress('register')}>Register Now</button>
                    <a onClick={async () => {
                        downloadCertifiedCompanies()
                    } } className="cursor-pointer text-xs text-blue-600 curser-pointer">
                    {` List of certified companies as of `+moment( ).format( "DD MMM, YYYY" )}
                  </a>
                  </div>

                  <div className="font-extrabold text-gray-500 text-7xl pt-8">
                    IT Certification <br/>
                    <div className="text-[#aec836]">in one place.</div>
                  </div>
                  
                  <div className="text-gray-600 text-3xl pt-12">
                    Upholding the Quality and Standards<br/>
                    of Uganda's IT Industry
                  </div>
                </div>
              }

              { showText === "certification" && 
                <div className="justify-center tracking-tighter py-10 px-20 text-sm">
                  <a onClick={async () => {
                        setShowCertifiedCompanies(true)
                    } } className="cursor-pointer text-xs text-blue-600 curser-pointer">
                    {` List of certified companies`}
                  </a>
                  <h4 className="text-green-600">Certification</h4>
                  With a view to enhance the competitiveness of Ugandan IT Industry globally and to regulate the IT Products & Services, IT Training and Individual IT Service Providers in Uganda, there is a need to outline the minimum acceptable standards and to certify eligible entities to applicable international standards.<br/>

                  The IT Certification Project (ITCP) was thus formulated for standardisation in the planning, acquisition, implementation, delivery, support and maintenance of Information technology equipment and services to ensure uniformity in Quality, adequacy and reliability of Information technology usage throughout Uganda.<br/>

                  Considering the present state of the IT industry in the country and the need to provide entities time to get into the Certification process, NITA-U shall issue Conformity Certificates at various levels to those entities that meet the defined eligibility criteria for these levels.<br/><br/>

                  <h6 className="text-green-600">There are Four IT domains for which Certification is being provided</h6>

                  <table className="border-collapse border border-slate-400">
                    <tr>
                      <td className="border border-slate-300">
                        <b>IT Service Providers :</b>
                      </td>
                      <td className="border border-slate-300">
                        Those entities which provide IT products and services including suppliers, application solution providers, consultants, service delivery points (e.g. Internet Cafes), etc
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-slate-300">
                        <b>E-Transactions Providers :</b>
                      </td>
                      <td className="border border-slate-300">
                      Entities which provide activities such as Financial service activities, Insurance, reinsurance and pension funding, betting, gambling, Activities auxiliary to financial service and insurance activities etc
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-slate-300">
                        <b>IT Training Institutions :</b>
                      </td>
                      <td className="border border-slate-300">
                        Entities which are conducting training in Computing and Information technology. These could be schools, tertiary institutions, companies or organizations conducting any form of IT Training in a formal or non-formal setting
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-slate-300">
                        <b>Individual IT Service Providers :</b>
                      </td>
                      <td className="border border-slate-300">
                      Those individuals who possess a Certificate/Diploma/Degree in any IT related subject/topic and is able to demonstrate knowledge, on-going commitment to professional development via an appropriate combination of qualifications, certifications, work experience non-formal and/or informal education.
                      </td>
                    </tr>
                  </table>
                </div>
              }

              { showText === "it_services" && 
                <div className="justify-center tracking-tighter py-10 px-20 text-sm">
                  <a onClick={async () => {
                        setShowRequiredDocuments(true)
                    } } className="cursor-pointer text-xs text-blue-600 curser-pointer">
                    {` Click to view required documents`}
                  </a>
                  <h4 className="text-green-600">IT Service Providers</h4>
                  Providers of IT Products and Services that include Suppliers, Application-solution Providers, Consultants, Service-delivery Points and other IT Service Providers as per the Classification.<br/>

                  With a view to enhance the competitiveness of Ugandan IT Industry globally and to regulate the IT Services in Uganda, there is a need to outline the minimum acceptable standards and to certify eligible entities to applicable international standards.<br/><br/>

                  The IT Certification Project (ITCP) was thus formulated for standardisation in the planning, acquisition, implementation, delivery, support and maintenance of Information technology equipment and services to ensure uniformity in Quality, adequacy and reliability of Information technology usage throughout Uganda.<br/>

                  Certification is granted to entities that are able to evidence complete conformity to the prescribed standards. The preparation for adoption and adherence to the certification standards by the entities concerned involves understanding the requirements, defining processes, its implementation and sustenance.<br/><br/>

                  Considering the present state of the IT industry in the country and the need to provide entities time to get into the Certification process, NITA-U shall issue Conformity Certificates at Levels 1, 2, 3 to those entities that meet the defined eligibility criteria for these levels.<br/>

                  The Level 1 and 2 certified entities are encouraged to build Competency and Capacity through resources and procedures for establishing a Management system that conforms to the requirements of an applicable ISO standard required for Level 3 certification.
                </div>
              }

              { showText === "e_transactions" && 
                <div className="justify-center tracking-tighter py-10 px-20">
                  <a onClick={async () => {
                        setShowRequiredDocuments(true)
                    } } className="cursor-pointer text-xs text-blue-600 curser-pointer">
                    {` Click to view required documents`}
                  </a>
                  <h4 className="text-green-600">E Transactions</h4>
                  E-Transactions are activities such as Financial service activities, Insurance, reinsurance and pension funding, Activities auxiliary to financial service and insurance activities, etc.<br/>
                  They also include:<br/>
                  <ol className="list-decimal p-10">
                    <li>Online Transactions e.g e-payments</li>
                    <li>Operations of Gambling facilities such as Casinos</li>
                    <li>Bookmaking and other betting operations</li>
                    <li>Off-track betting</li>
                    <li>Sale of lottery tickets</li>
                    <li>Operation (exploitation) of coin-operated gambling machines</li>
                    <li>Operation of virtual gambling web sites</li>
                    <li>Insurance, Banking, etc</li>
                  </ol>
                </div>
              }

              { showText === "training_institution" && 
                <div className="justify-center tracking-tighter py-10 px-20 text-sm">
                  <a onClick={async () => {
                        setShowRequiredDocuments(true)
                    } } className="cursor-pointer text-xs text-blue-600 curser-pointer">
                    {` Click to view required documents`}
                  </a>
                  <h4 className="text-green-600">IT Training Institutions</h4>
                  An entity providing IT Training in any Information and Communication Technology (ICT) related subject is referred as IT Training Institution.<br/>

                  With a view to enhance the competitiveness of Ugandan IT Industry globally and to regulate the IT Training in Uganda, there is a need to outline the minimum acceptable standards and to certify eligible entities to applicable international standards. The IT Certification Project (ITCP) was thus formulated for standardisation in the planning, acquisition, implementation, delivery, support and maintenance of Information technology equipment and services to ensure uniformity in Quality, adequacy and reliability of Information technology usage throughout Uganda. <br/><br/>

                  Certification is granted to entities that are able to evidence complete conformity to the prescribed standards. The preparation for adoption and adherence to the certification standards by the entities concerned involves understanding the requirements, defining processes, its implementation and sustenance. <br/>

                  Considering the present state of the IT industry in the country and the need to provide entities time to get into the Certification process, NITA-U shall issue Conformity Certificates at Levels 1, 2, 3 to those entities that meet the defined eligibility criteria for these levels. <br/>

                  The Level 1 and 2 certified entities are encouraged to build Competency and Capacity through resources and procedures for establishing a Management system that conforms to the requirements of an applicable ISO standard required for Level 3 certification. <br/>
                </div>
              }

              { showText === "it_products" && 
                <div className="justify-center tracking-tighter py-10 px-20 text-sm">
                  <a onClick={async () => {
                        setShowRequiredDocuments(true)
                    } } className="cursor-pointer text-xs text-blue-600 curser-pointer">
                    {` Click to view required documents`}
                  </a>
                  <h4 className="text-green-600">IT Products</h4>
                  <p>
                  With a view to regulate the IT Products, IT Services, IT Training, and Individual IT Service Providers in Uganda, an IT Certification Project (ITCP) has been initiated by National Information Technology Authority, Uganda. The objective of certifying IT Products is to minimize the risk of unsafe and sub-standard goods being traded in Uganda by conducting conformity assessment at source or before it enters the Ugandan market place. This will help ensure that consumers are protected from unsafe and sub-standard goods.
                  </p><br/>

                  <p>
                  As a Partner State of the East African Community (EAC), the product certification scheme for IT Products shall be broadly in-line with the East African Community Standardization Quality Assurance Metrology and Testing Act 2006, also referred as EAC SQMT Act. The NITA-U IT Certification Office has been set up to carry out the Certification process in accordance with the guidelines of the Certification framework. The NITA-U IT Certification Office is responsible for the receipt of the Applications, Verification, Validation, conformity Assessment and Certification of the objects of conformity assessment as per the Certification Framework. The NITA-U IT Certification Office shall also guide and assist the Applicants on the Certification processes.
                  </p><br/>

                  <p>
                  A Certification Framework for IT Products has been created to lay down end-to-end Guidelines, Certification standards, Processes and Practices to be followed for issuances of Conformity Certificates to IT Products. The IT Products to be certified can be imported directly by the user, or by a trader. The IT Products can also be locally manufactured or assembled.
                  </p>
                </div>
              }

              { showText === "individual_it_service_providers" && 
                <div className="justify-center tracking-tighter py-10 px-20">
                  <a onClick={async () => {
                        setShowRequiredDocuments(true)
                    } } className="cursor-pointer text-xs text-blue-600 curser-pointer">
                    {` Click to view required documents`}
                  </a>
                  <h4 className="text-green-600">IT Consultants</h4>
                  <p className="text-sm">
                  An Individual IT Service Provider is an individual having knowledge and/or Experience in the Information Technology domain and is able to add value to any office, or establishment, where and when positioned.

                  With a view to enhance the competitiveness of Ugandan IT Industry globally and to regulate the IT Products & Services, IT Training and Individual IT Service Providers in Uganda, there is a need to outline the minimum acceptable standards and to certify eligible entities to applicable international standards.

                  The IT Certification Project (ITCP) was thus formulated for standardization in the planning, acquisition, implementation, delivery, support and maintenance of Information technology equipment and services to ensure uniformity in Quality, adequacy and reliability of Information technology usage throughout Uganda.

                  The IT workforce worldwide, besides formal IT education, has entered the IT Industry through different routes like, informal IT knowledge, or structured IT experience, or unstructured IT exposure, or combinations of these. There exists a need to carry out conformity assessment of the IT competencies and certify those who are able to demonstrate conformity to the competency standards laid down in as per the certification framework.

                  The NITA-U IT Certification Office has been set up to carry out the Certification process in accordance with the guidelines of the Certification framework. The NITA-U IT Certification Office shall be responsible for receipt of the applications from the applicant, carry out verification, validation, conformity assessment, and thereafter grant certification to the concerned individual as per the Certification Framework. The NITA-U IT Certification Office shall also guide and assist the Applicants on the Certification processes.
                  </p>
                </div>
              }

              { showText === "help_and_support" && 
                <div className="justify-center tracking-tighter py-20 px-20">
                  {/* <a onClick={async () => {
                        setShowRequiredDocuments(true)
                    } } className="cursor-pointer text-xs text-blue-600 curser-pointer">
                    {` Click to view required documents`}
                  </a> */}
                  <h4 className="text-green-600">Help and Support</h4>
                  <strong>ITCO:</strong> <a href="https://itco.go.ug/" className="hover:cursor-pointer text-blue-500">itco.go.ug</a><br />
                  <strong>ITCO Address:</strong> IT Certification Office, Plot 7A, Palm Courts, Rotary Avenue (Former Lugogo Bypass)<br />
                  <strong>By Post:</strong> P.O. Box 33151, Kampala - Uganda<br />
                  <strong>By Phone:</strong>  +256-785-807169 <br/>
                  <strong>Email:</strong> <a href="/contactus/">servicedesk@gou.go.ug</a>
                </div>
              }

              <div className="">
                <img src={BannerImg} className="w-full object-contain"/>
              </div>
            </div>
          </div>
          {/* start of required docs modal */}
          <ModalComponent title={`Required documents`} open={showRequiredDocuments}>
            <div className="flex flex-col items-center justify-center">
              <table className="text-gray-700 py-1 text-xs border-collapse table-fixed overflow-x-scroll">
                <tr className="text-xs p-2 text-left">
                  {showText === "it_services" &&
                    <ol className="list-decimal p-5">
                      <h2 className="font-extrabold">IT Services documents</h2>
                      <li>Certified certificate of incorporation (URSB)</li>
                      <li>Tax Registration Certificate</li>
                      <li>Certified/Commissioned academic degree transcripts/certificates for your technical staff. i.e.
                        diplomas, bachelors, masters etc.</li>
                      <li>A self-declaration or Affidavit (attestation that the entity is not debarred from doing business with
                        the Government of Uganda)</li>
                      <li>If available, Experience in IT service provision i.e. completion certificates, Purchase orders,
                        Contracts (cover, first &amp; signatory pages) etc.</li>
                      <li>A Title deed, valid tenancy/lease agreement, recent rent receipts as proof of office location.</li>
                    </ol>
                  }

                  {showText === "e_transactions" &&
                  <>
                    <h2 className="font-extrabold mb-2">E-transaction documents</h2>

                    Legal requirements: <br/>
                    <ol className="list-decimal pb-2 pl-5">
                      <li><b>Certified</b> Certificate of Incorporation </li>
                      <li>Tax Registration Certificate </li>
                      <li><b>Certified/notarized</b> academic degree transcripts/certificates for your technical staff. i.e. diplomas, bachelors, masters etc.</li>
                      <li>Tenancy Agreement</li>
                    </ol>

                    Required documentary evidence:<br/>
                    <ol className="list-decimal pb-2 pl-5">
                      <li> Code of conduct (for your staff) detailing written collection of the rules, principles, values and employee expectations, behavior, and relationships that the company considers significant and believes are fundamental to its successful operations</li>
                      <li> Terms or conditions of agreement, including any guarantees, that apply to your systems </li>
                      <li> Internal complaints handling mechanisms </li>
                      <li> Alternative Dispute Resolution mechanisms </li>
                      <li> Staff confidentiality & non-disclosure agreements </li>
                      <li> Data retention mechanism/policy </li>
                      <li> Internal information security awareness for staff </li>
                    </ol>

                    Required IT policies covering the following areas for the company:
                    <ol className="list-decimal pb-2 pl-5">
                      <li>Risk management</li>
                      <li>Security roles and responsibilities</li>
                      <li>Information Security</li>
                      <li>Remote Access </li>
                      <li>Access control</li>
                      <li>Acceptable use of Information Assets</li>
                      <li>Network security</li>
                      <li>Secure software Development</li>
                      <li>Supplier Management</li>
                      <li>Capacity Management</li>
                      <li>Change Management</li>
                      <li>Anti-Malware</li>
                      <li>Backup and Recovery</li>
                      <li>Incident management</li>
                      <li>Business continuity</li>
                      <li>External IT Audits</li>
                    </ol>

                    Prepare for a process walkthrough of the following:
                    <ol className="list-decimal pb-2 pl-5">
                      <li>High level logical design of the payment systems and related applications</li>
                      <li>High level integration design with clients (API setup)</li>
                      <li>Transactions transparency and reviews</li>
                    </ol>
                  </>
                  }

                  {showText === "training_institution" &&
                    <ol className="list-decimal p-5">
                      <h2 className="font-extrabold">Training institution documents</h2>
                      <li>Document of ownership or Organization registration documents e.g. Certificate of Incorporation.</li>
                      <li>Valid license to operate as IT Training Institution in Uganda.</li>
                      <li>Proof of Address of the organization premises.eg. Electricity bill, Tenancy agreement.</li>
                      <li>Income tax clearance certificate indicating no outstanding income tax dues on the organization.</li>
                      <li>Official legal Affidavit / Self-declaration confirming that the entity is not debarred from doing business with the Govt. of Uganda.</li>
                    </ol>
                  }

                  {showText === "it_products" &&
                    <ul>
                      <li>IT products documents</li>
                    </ul>
                  }

                  {showText === "individual_it_service_providers" &&
                    <ol className="list-decimal p-5">
                      <h2 className="font-extrabold">Documentation for IT Consultants</h2>
                      <li>A National ID.</li>
                      <li>Valid Proof of Address.</li>
                      <li>Certified/notarized academic degree transcripts/certificates, training and experience certifications proving that the individual has undergone a formal IT training.</li>
                      <li>A self-declaration or Affidavit confirming that he/she is not debarred from doing business with the Government of Uganda.</li>
                      <li>Referral letters from two referees who are conversant with the individual’s credentials and work experience</li>
                      <li>Work experience in previous IT related positions held. i.e. previous contracts, appointment letters etc.</li>
                    </ol>
                  }

                  {showText === "help_and_support" &&
                    <ol className="list-decimal p-5">
                      <h2 className="font-extrabold">Help and Support</h2>
                        <strong>ITCO:</strong> <a href="http://www.itco.go.ug">www.itco.go.ug</a><br />
                        <strong>ITCO Address:</strong> IT Certification Office, Plot 7A, Palm Courts, Rotary Avenue (Former Lugogo Bypass)<br />
                        <strong>By Post:</strong> P.O. Box 33151, Kampala - Uganda<br />
                        <strong>By Phone:</strong>  +256417801053 <br/>
                        <strong>By Mobile:</strong>  +256785807169 / +256759848259 <br/>
                        <strong>Email:</strong> <a href="/contactus/">servicedesk@gou.go.ug</a>
                    </ol>
                  }
                </tr>
              </table>
              
              <button onClick={async () => {
                setShowRequiredDocuments(false)
                } } className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center">
                Close
              </button>
            </div>
          </ModalComponent>

          <ModalComponent title={`List of Certified Companies`} open={showCertifiedCompanies}>
            <button onClick={async () => {
              setShowCertifiedCompanies(false)
              } } className="cursor-pointer w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex justify-center float-end">
              Close
            </button>

            <div className="flex flex-col justify-center w-100 bg-white">             
                        
              <Table 
              rightButton={false}
              rightBtnCallback={ () => {}}
              rightButtonLabel={null}
              label="My Reports"
              columns={columns}
              data={records}
              hidePagination={false}
              exportToExcel={() => {}}
              exportToCSV={() => {}}
              />
            </div>
          </ModalComponent>


          <ModalComponent title={showText === "cookie_notice" ? `Cookie Use Notice`: `ITCO Website Privacy Notice`} open={showItcoPrivacyNotice}>
            <div className="flex flex-col">
              {showText === "privacy_policy" &&
                <div className="text-sm overflow-y-auto">
                  <p>
                    <strong>1. About this Notice <br/> </strong>

                    This Privacy Notice applies to the National Information Technology Authority – Uganda (NITA-U) IT Certification website accessed at itco.nita.go.ug and related services. 
                    We recommend that you read this Privacy Notice to ensure you are fully informed about how we collect and process your personal data.
                  </p>

                  <p>
                    <strong>2. Data Controller <br/> </strong>

                    The Personal Data Protection and Privacy Act, 2013 defines a data controller as a person who alone, jointly with other persons or in common with other persons or as a statutory duty determines the purposes for and the manner in which personal data is processed or is to be processed.
                    
                    The National Information Technology Authority – Uganda (NITA-U) is the data controller of personal data collected and processed through this website.
                  </p>


                  <p>
                    <strong>3. The Data We Collect</strong><br/>
                    Personal data means any information about a person from which the person can be identified, that is recorded in any form. We collect personal data as part of the information required to process your application for certification as a provider of Information Technology (IT) products and services or for Authentication as an IT Training institution. We also collect your personal data when you create an account on the IT Certification website. We do not use any automated means to collect your personal data. 
                    The personal data that we collect includes:
                    <ol>
                      <li>First name and last name of the contact persons and IT professionals</li>
                      <li>Phone number and E-mail address to facilitate communication between us and yourself</li>
                      <li>Identity Data for those seeking IT Individual Service Provider certification</li>
                      <li>Academic information of IT professionals to demonstrate that a company has the required competence to provide IT products and services.</li>
                    </ol>
                  </p>

                  <p>
                    <strong>4. The purpose for the personal data we collect and process<br/></strong>
                    <ol>
                      <li>To enable you create an account on the website</li>
                      <li>To support the set of processes that we undertake to determine IT Training Institutions and providers of IT products and services who have applied and meet the standard requirements for certification/authentication.</li>
                      <li>To support communication between yourself and us during the certification/authentication process</li>
                      <li>To communicate with you when you write to us through the ‘contact us’ web form or service desk email. This is to enable our in-house service desk team to follow up on any clarification, inquiry or complaint raised by a user. </li>
                      <li>To share updates and information related to IT Certification/authentication of IT training institutions with those on the register.</li>
                    </ol>
                  </p>

                  <p>
                    <strong>5. Legal basis for the processing of Personal Data</strong><br/>
                    <ol>
                      <li>We collect your personal data as a requirement of the National Information Technology Authority, Uganda Act (2009), the Electronic Transactions Act (2011), NITA-U (Certification of IT Providers and Services) Regulations and the NITA-U (Authentication of IT Training) Regulations;</li>
                      <li>The Legal basis relied upon to collect and process personal data that you provide to us when you write to us the service desk or contact us webform is ‘legitimate interest’ as defined in the Data Protection and Privacy Regulations (Regulation 10(2)(b)).</li>
                    </ol>
                  </p>

                  <p>
                    <strong>6. Disclosure</strong><br/>

                    We may share your personal data with our vendors, partners and third parties as required to support the IT Certification/Authentication process. In such circumstances, we only undertake this in accordance with our instructions and contracts. We do not allow our third-party service providers to use your personal data for their own purposes.<br/>
                    In addition, we may share your personal data with Courts of Law/ Law enforcement or relevant Government Agencies in accordance with the applicable law when requested. <br/>We otherwise do not share personal data with any third party during the normal course of the IT Certification/Authentication process.
                  </p>

                  <p>
                    <strong>7. Protection of Personal Data</strong><br/>

                    Personal data collected during the certification/authentication process is secured with the state-of-the-art data security controls. This website is securely hosted in the Government National Data Center with the appropriate technical and organizational security controls. 
                    <br/>
                    In addition, we have a skilled support team that maintains the operational security (technical and organizational) controls for this website.
                  </p>

                  <p>
                    <strong>8. Your Rights</strong><br/>

                    The Personal Data Protection and Privacy Act (2019) provides for rights of data subjects including the right to access personal data, the right to prevent processing of personal data, the right to prevent processing of personal data for direct marketing, rights related to automated decision-making as well as rectification, erasure among others.
                    <br/>
                    Should you require more information regarding how you may enforce these rights or to submit a request in line with the provided data subject rights you may contact us via dpo@nita.go.ug. <br/>Requests and complaints received will be responded to within the timelines provided for in the Data Protection and Privacy Regulations (2021).
                  </p>

                  <p>
                    <strong>9. Data Retention</strong><br/>

                    We retain personal data as required by the National Records and Archives Act (2001) and the Uganda Public Service Standing Orders. 
                  </p>

                  <p>
                    <strong>10. Contacts & Revisions</strong><br/>

                    The data protection officer can be contacted at dpo@nita.go.ug. A complaint can also be filed with our office using the address below:<br/>
                    Executive Director<br/>
                    Attention: Data Protection Officer<br/>
                    National Information Technology Authority - Uganda (NITA-U)<br/>
                    Palm Courts, Plot 7A, Rotary Avenue (Former Lugogo Bypass)<br/>
                    P.O. Box 33151, Kampala - Uganda  <br/>
                    Telephone: +256-417-801038<br/><br/>
                    
                    This Privacy Notice may be updated from time to time and to reflect the changes will be published here. While we shall make reasonable efforts to notify you through suitable communication channels of any changes, you are advised to check this website frequently to see any recent changes.<br/>
                    If you have any comments or queries in relation to this Privacy Notice, please forward same to our Data Protection Officer at dpo@nita.go.ug. <br/>After engaging us, should your queries/complaints still not be addressed to your satisfaction, you have the right to lodge a formal complaint with the Personal Data Protection Office at www.pdpo.go.ug
                  </p>

                  <p>
                  Version 2.0 – November 2023.
                  </p>
                </div>
              }

              {showText === "cookie_notice" &&
                <div className="text-sm overflow-y-auto">
                  <p>
                    {/* <strong>Cookie Use Notice <br/> </strong> */}

                    This Cookie Use Notice applies to the National Information Technology Authority – Uganda (NITA-U) IT Certificate website accessed via itco.go.ug<br/>This Cookie Notice explains how we use cookies and similar technologies.<br/><br/>
                  </p>

                  <p>
                    <strong>What are Cookies? <br/> </strong>

                    Cookies are small text files with small pieces placed on your computer by websites that you visit. They are widely used in order to improve the website browsing experience.<br/><br/>
                    The table below explains the cookies we use and why:
                    <table className="border-collapse border border-slate-400 table-auto">
                      <thead>
                        <tr>
                          <th class="border border-slate-300">Cookie Name</th>
                          <th class="border border-slate-300">Purpose</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="border border-slate-300">csrftoken</td>
                          <td class="border border-slate-300">A CSRF token is a unique, secret, and unpredictable value that is generated by the server-side application and shared with the client. It’s used as a best practice to prevent Cross-Site Request Forgery (CSRF) attacks.</td>
                        </tr>
                      </tbody>
                    </table><br/>
                    We do not use the analytics data to identify individuals’ personal data when you access our website. In addition, to the above, Third-Party Cookies maybe installed on your computer. Third-Party Cookies are created by domains that are not the website that you are visiting.  Basically, a third-party cookie is placed on a website by someone other than the owner (a third party) and collects user data for the third party.<br/>
                  </p>

                  <p>
                    <strong>Your options on managing Cookie Settings <br/> </strong>

                    Third-party cookies may be blocked and deleted through your browser settings. Here is more information:<br/>
                    <a href="https://support.mozilla.org/en-US/kb/third-party-cookies-firefox-tracking-protection" target="_blank" className="text-blue-700 hover:cursor-pointer"> - Firefox</a> <br/>
                    <a href="https://support.google.com/chrome/answer/95647?hl=en&co=GENIE.Platform%3DDesktop" target="_blank" className="text-blue-700 hover:cursor-pointer"> - Chrome </a>  <br/>
                    <a href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac" target="_blank" className="text-blue-700 hover:cursor-pointer"> - Safari </a><br/>
                    <a href="https://support.microsoft.com/en-us/microsoft-edge/issue-with-blocking-third-party-cookies-f91209bd-0104-2446-61be-d2e4d7da64da" target="_blank" className="text-blue-700 hover:cursor-pointer"> - Edge </a> <br/>
                    <a href="https://blogs.opera.com/news/2015/08/how-to-manage-cookies-in-opera/" target="_blank" className="text-blue-700 hover:cursor-pointer"> - Opera </a> <br/>
                     In addition to the above, Google has an ‘Opt-out Browser Add-on’ that individuals may use to prevent their usage data from being used by the Google Analytics service. More information can be accessed <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" className="text-blue-700 hover:cursor-pointer">here</a> 
                  </p>

                  <p><br/>
                    Version 1.0 –  November 2023
                  </p>
                </div>
              }
              <button onClick={async () => {
                setShowItcoPrivacyNotice(false)
                } } className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center">
                Close
              </button>
            </div>
          </ModalComponent>
          {/* end of required docs modal */}
        </div>
       
        <div className="flex items-center justify-center absolute h-12 sm:h-14 md:h-20 lg:h-20 bottom-0 left-0 w-full bg-white">
            <div>
                <span className="text-xs">{`Terms of Use Limitation of Liability`} |  
                  <a onClick={async () => {
                        setShowItcoPrivacyNotice(true)
                        setShowText("privacy_policy")
                    } } className="cursor-pointer text-xs text-blue-600 curser-pointer">
                    {` Privacy Notice`}
                  </a> &nbsp;
                   |  
                  <a onClick={async () => {
                        setShowItcoPrivacyNotice(true)
                        setShowText("cookie_notice")
                    } } className="cursor-pointer text-xs text-blue-600 curser-pointer">
                    {` Cookie Use Notice`}
                  </a>
                </span>
            </div>
            <div className="px-2">
                <span className="text-xs">{`Copyright`}</span>
            </div>
        </div>
    </div>
  )
}